<template>
    <div class="search-block">

      <div class="search-icon"
           :class="{active:isInputShown}"
           @click="isInputShown = !isInputShown"
      ></div>

      <div class="search-show-block" v-if="isInputShown">
        <div>
          <input class="search-input"
                 type="text"
                 name="search"
                 @keyup.enter="showAll"
                 v-model="search">
          <button class="my-button blink-button"
                  @click="showAll">Поиск</button>
        </div>

        <div class="search-result" v-if="products && products.length > 0">
          <div>
            <div class="result-item" v-for="(product, key) in products"
                 :key="'search_product_' + key">
              <a :href="product.url">
                <img :src="product.imageUrl" :alt="product.imageAlt">
                <span>{{product.name}}</span>
              </a>
            </div>
          </div>

          <div class="d-flex mt-4">
            <div @click="showAll" class="my-link">Показать еще</div>
          </div>

        </div>
      </div>

    </div>
</template>

<script>
var urlParams = new URLSearchParams(window.location.search);
  export default {
    name: 'header-search-input',
    data() {
      return {
        isInputShown: false,
        search: '',
        limit: 5,
        products: null,
        searchUrl: '/search/fraze-{0}',
      }
    },
    watch: {
      search: {
        handler: _.debounce(
          function () {
            if(this.search.length > 3) {
              this.searchProducts();
            }
          }, 500
        ),
        deep: true
      },
    },
    methods: {
      searchProducts() {
        axios.get(`/product-search?limit=${this.limit}&search=${this.search}`).then(res => {
            this.products = res.data;
            console.log(this.products);
        })
      },
      showAll() {
        location = this.searchUrl.format(this.search);
      }
    },
  }
</script>